import React from 'react';
import PropTypes from 'prop-types';
import css from './Dropdown.module.scss';

const Dropdown = ({
  label,
  value,
  onChange,
  options = [],
  placeholder = null,
  required = false,
  disabled = false,
  error = '',
  name,
  labelPosition = 'top',
  style,
  icon = null,
  size,
}) => {
  const handleChange = (e) => {
    onChange(e);
  };

  return (
    <div className={`${css.dropdownContainer} ${css[`label-${labelPosition}`]}`} style={style}>
      {label && (
        <label className={css.label}>
          {label}
          {required && <span className={css.required}>*</span>}
        </label>
      )}
      <div className={css.selectWrapper}>
        {icon &&
          <div className={css.icon}>
            {icon}
          </div>
        }
        <select
          className={`${css.select} ${error ? css.error : ''} ${disabled ? css.disabled : ''} ${icon ? css.withIcon : ''} ${size === 'small' ? css.small : ''}`}
          value={value}
          onChange={handleChange}
          disabled={disabled}
          name={name}
          required={required}
          data-error={!!error}
        >
        {placeholder &&
          <option value="" disabled className={css.placeholder}>
            {placeholder}
          </option>
        }
        {options.map((option) => (
          <option
            key={option.value}
            value={option.value}
            disabled={option.disabled ?? false}
          >
            {option.label}
          </option>
        ))}
        </select>
      </div>
      {error && <span className={css.errorMessage}>{error}</span>}
    </div>
  );
};

Dropdown.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  placeholder: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.oneOf([null]),
  ]),
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  name: PropTypes.string.isRequired,
  icon: PropTypes.node,
  size: PropTypes.oneOf(['small']),
};

export default Dropdown;
